import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import { MBL_SIZE, TBL_SIZE } from "@directv-digital/dds.ui.dtv-theme";
import CardMedia from "@mui/material/CardMedia";
import { CardSvodsSectionProps } from "../../../flip-cards.props";

const svodReflectionStyles = {
  position: "absolute",
  top: "100%",
  left: 0,
  width: "100%",
  height: "30%",
  overflow: "hidden",
  pointerEvents: "none",
  display: "flex",
  alignItems: "flex-end",
  transform: "scaleY(-1)",
  opacity: 0.6,
  maskImage: "linear-gradient(to top, rgba(0,0,0,1) 15%, rgba(0,0,0,0.5) 30%, transparent 60%)",
  WebkitMaskImage: "linear-gradient(to top, rgba(0,0,0,1) 15%, rgba(0,0,0,0.5) 30%, transparent 60%)",
  "& img": {
    filter: "blur(4px)"
  },
  [`@media ${MBL_SIZE}`]: {
    opacity: 0.4,
    maskImage: "linear-gradient(to top, rgba(0,0,0,0.6) 20%, rgba(0,0,0,0.3) 40%, transparent 80%)",
    WebkitMaskImage: "linear-gradient(to top, rgba(0,0,0,0.6) 20%, rgba(0,0,0,0.3) 40%, transparent 80%)",
    "& img": {
      filter: "blur(6px)"
    }
  }
};

const CardSvodsSection = (props: CardSvodsSectionProps) => {
  const { svods } = props;

  if (!Array.isArray(svods) || svods.length === 0) {
    return null;
  }

  try {
    return (
      <DtvBox
        sx={{
          px: {
 xs: "16px",
md: "24px"
},
          mb: {
 xs: "8px",
sm: "12px",
md: "8px"
}
        }}
      >
          <DtvBox
            sx={{
              display: "flex",
              gap: "8px"
            }}
          >
            {svods?.map(
              (svod, index) => svod?.name &&
                svod?.logo?.default && (
                  <DtvBox key={index} sx={{
 width: {
 xs: "44px",
sm: "44px",
md: "64px"
},
position: "relative"
}}>
                    <DtvBox sx={{
 height: {
 xs: "44px",
sm: "44px",
md: "64px"
}
}}>
                      <picture style={{
 width: "100%",
height: "100%"
}}>
                        <source media={MBL_SIZE} srcSet={svod?.logo?.mobile || svod?.logo?.default} />
                        <source media={TBL_SIZE} srcSet={svod?.logo?.tablet || svod?.logo?.default} />
                        <CardMedia
                          component="img"
                          loading={"eager"}
                          decoding="async"
                          src={svod?.logo?.default}
                          alt={svod?.name || `icon-${index}`}
                          onError={e => {
                            console.error(`[FlipCards][CardSvodsSection] untracked icon error for index ${index}`, e);
                          }}
                          sx={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "2px",
                            objectFit: "contain",
                            display: "block"
                          }}
                        />
                      </picture>
                    </DtvBox>
                    <DtvBox sx={svodReflectionStyles} aria-hidden="true">
                      <picture style={{ width: "100%" }}>
                        <source media={MBL_SIZE} srcSet={svod?.logo?.mobile || svod?.logo?.default} />
                        <source media={TBL_SIZE} srcSet={svod?.logo?.tablet || svod?.logo?.default} />
                        <CardMedia
                          component="img"
                          loading={"lazy"}
                          decoding="async"
                          src={svod?.logo?.default}
                          alt=""
                          sx={{
                            width: "100%",
                            borderRadius: "2px",
                            objectFit: "cover",
                            display: "block"
                          }}
                        />
                      </picture>
                    </DtvBox>
                  </DtvBox>
                )
            )}
          </DtvBox>
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay error={error} component="CardSvodsSection" />;
  }
};

export default React.memo(CardSvodsSection);
